import { FC } from "react";
import styles from './Header.module.less';
import logo from '../../assets/logo1.svg';
import { useNavigate } from "react-router-dom";

const Header: FC = () => {
    const navigate = useNavigate();
    return (
        <div className={styles.header}>
            <div className={styles.fix}>
                <div className={styles.logo}>
                    <img className={styles.image} src={logo} alt="" />
                    {/* <div className={styles['logo-text']}>
                        实验室危化品管理平台
                    </div> */}
                </div>
                <div className={styles.navbar}>
                    <div className={styles['nav-item']} onClick={() => navigate('/')}>首页</div>
                    <div className={styles['nav-item']} onClick={() => navigate('/notification')}>通知公告</div>
                    <div className={styles['nav-item']} onClick={() => navigate('/download')}>文件下载</div>
                    <div className={styles['nav-item']} onClick={() => navigate('/contact')}>联系我们</div>
                </div>
            </div>
        </div>
    );
}

export default Header;